import { ref, onMounted, onUnmounted } from 'vue'

export function useNetworkStatus() {
    const isOnline = ref(navigator.onLine)
    const hasPendingWrites = ref(false)
    const isSyncing = ref(false)
    const justSynced = ref(false)

    let hideMessageTimeout = null

    const handleOnline = () => {
        isOnline.value = true
    }

    const handleOffline = () => {
        isOnline.value = false
        isSyncing.value = false
    }

    const showSyncedMessage = () => {
        isSyncing.value = false
        hasPendingWrites.value = false
        justSynced.value = true

        if (hideMessageTimeout) clearTimeout(hideMessageTimeout)
        hideMessageTimeout = setTimeout(() => {
            justSynced.value = false
        }, 3000)
    }

    onMounted(() => {
        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)
    })

    onUnmounted(() => {
        window.removeEventListener('online', handleOnline)
        window.removeEventListener('offline', handleOffline)
        if (hideMessageTimeout) clearTimeout(hideMessageTimeout)
    })

    // Called from components when they detect hasPendingWrites in snapshot metadata
    const setPendingWrites = (pending) => {
        const wasPending = hasPendingWrites.value;
        hasPendingWrites.value = pending;

        if (pending) {
            justSynced.value = false;
            isSyncing.value = isOnline.value; // online + pending => syncing
        } else {
            isSyncing.value = false;
            if (wasPending && isOnline.value) {
                showSyncedMessage()
            }
        }
    }

    return {
        isOnline,
        hasPendingWrites,
        isSyncing,
        justSynced,
        setPendingWrites
    }
}
